import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';

import store from '../../store';
import {FeatureSelectItem} from '../featureSelect/featureSelectItem';
import {luminaryOptions} from '../../sectionConfig';

@customElement('list-select-item')
export class ListSelectItem extends connect(store)(LitElement) {

	@property({type: Object})
	option = {};

	@property({type: String})
	selected = '';

	@property({type: String})
	action = '';

	@property({type: Boolean})
	canBeSelected = true;

	@property({type: Boolean})
	hideDisabled = false

	static styles = [
		css`
			:host {
				flex-grow: 1;
			}

			.item {
				position: relative;
				margin-bottom: 0;
				width: 100%;
			}

			.item button {
				width: 100%;
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				background-color: transparent;
				display: inline-block;
				height: var(--height-widget);
				min-width: var(--height-widget);
				cursor: pointer;
				white-space: nowrap;
				transition: background-color 0.4s, color 0.4s;
				padding: 8px 8px;
				text-align: center;
				border: 0 none;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
			}

			button:hover {
				background-color: var(--color-widget-background-hover);
			}

			.selected button {
				background-color: var(--color-widget-background-selected);
			}

			.fixed button {
				pointer-events: none;
			}

			.disabled button {
				color: var(--color-widget-border);
				pointer-events: none;
			}

			.disabled button:hover {
				color: var(--color-widget-border);
			}
        `];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
	}
	isSelected() {
		return this.selected === this.option.id;
	}

	isExcluded() {
		return false;
	}

	isDisabeled() {
		return !this.canBeSelected;
	}

	canBeExcluded() {
		return true;
	}

	async setOption() {
		if (this.action) {
			store.dispatch(
				{
					type: this.action,
					payload: {
						id: this.option.id
					}
				}
			);
		}
	}

	render() {
		return html`
			<div class="item ${classMap({selected: this.isSelected(), disabled: this.isDisabeled(), hideDisabled: this.hideDisabled, fixed: !this.canBeExcluded()})}">
				<button @click="${this.setOption}">
					${this.option.label[this.lang]}
				</button>
				<!--
				${when(this.option.info && this.option.info !== '' && this.option.info !== null, () => html`
					<div class="hoverinfo">
						<div class="content">
							${this.option.info[this.lang]}
						</div>
					</div>
				`)}
				-->
			</div>
		`;
	}
}
